/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect } from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import classNames from "classnames";
import useTranslation from "locales";

import HeaderDropdown from "../HeaderDropdown";

import MobileMenu from "../MobileMenu";

import "./header.scss";
import LogoH from "../../assets/images/logo-horizontal.svg";
import LogoV from "../../assets/images/logo-vertical.svg";

const Header = ({ lang, newsletter, dismissed, data }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);

  const { t } = useTranslation(lang);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScrolled(window.scrollY > 0);
    });
  });

  // const gardensOptions = [
  // 	{
  // 		key: "PP",
  // 		label: t("Piotruś Pan"),
  // 		city: t("Warszawa"),
  // 		url: t("https://piotruspan.ogrodswiatel.pl/"),
  // 	},
  // 	{
  // 		key: "LA",
  // 		label: t("Lampa Aladyna"),
  // 		city: "Chorzów",
  // 		url: t("https://lampaaladyna.ogrodswiatel.pl/"),
  // 	},
  // 	{
  // 		key: "LA",
  // 		label: t("Królewna Śnieżka"),
  // 		city: "Kraków",
  // 		url: t("https://krolewnasniezka.ogrodswiatel.pl/"),
  // 	},
  // ];

  const gardensOptions = data.info.nodes[0].acfInformation.acfInformation.menu;

  const aboutOptions = [
    {
      key: "0",
      label: t("O firmie"),
      url: t("/o-firmie/"),
    },
    {
      key: "1",
      label: t("Nasze realizacje"),
      url: t("/nasze-realizacje/"),
    },
    {
      key: "2",
      label: t("Kariera"),
      url: t("/kariera/"),
    },
  ];

  return (
    <header>
      <div
        className={classNames(
          `header`,
          { [`header--shrink`]: scrolled },
          { [`header--dismissed`]: !dismissed }
        )}
      >
        <div className="container header__container">
          <Link to={t("/")} className="header__logo-link">
            <img
              src={LogoH}
              className="header__logo header__logo--horizontal"
              alt="Ogród Świateł"
            />
            <img
              src={LogoV}
              className="header__logo header__logo--vertical "
              alt="Ogród Świateł"
            />
          </Link>
          <ul className="header__nav">
            <li className="header__nav-item">
              <HeaderDropdown
                placeholder={t("Wybierz Ogród Świateł")}
                gardensOptions={gardensOptions}
              />
            </li>
            <li className="header__nav-item">
              <HeaderDropdown
                placeholder={t("O nas")}
                options={aboutOptions}
                link
              />
            </li>
            <li className="header__nav-item header__nav-item--btn">
              {newsletter ? (
                <Link
                  className="btn newsletter_button newsletter"
                  to="/#newsletter"
                >
                  {t("Zapis do newslettera")}
                </Link>
              ) : (
                <a
                  href={t("https://bilety.ogrodswiatel.pl/")}
                  className="btn newsletter_button"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                >
                  {t("Kup bilet")}
                </a>
              )}
            </li>
            <li className="header__nav-item">
              <HeaderDropdown language={lang} placeholder={lang} />
            </li>
          </ul>
          {/* Mobile Nav */}
          {newsletter ? (
            <Link
              className={classNames(
                `btn`,
                `burger-menu__btn`,
                "burger-menu__newsletter",
                {
                  [`burger-menu__btn--hidden`]: mobile,
                }
              )}
              to="/#newsletter"
            >
              {t("Zapis do newslettera")}
            </Link>
          ) : (
            <a
              href={t("https://bilety.ogrodswiatel.pl/")}
              className={classNames(`btn`, `burger-menu__btn`, {
                [`burger-menu__btn--hidden`]: mobile,
              })}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {t("Kup bilet")}
            </a>
          )}
          <div
            onClick={(e) => setMobile(!mobile)}
            className={classNames(`burger-menu`, {
              [`burger-menu--close`]: mobile,
            })}
          >
            <span></span>
          </div>
        </div>
      </div>
      <div
        className={classNames(`header__spacer`, {
          [`header__spacer--dismissed`]: !dismissed,
        })}
      />
      {/* Mobile Menu */}
      <MobileMenu
        newsletter={newsletter}
        gardensOptions={gardensOptions}
        abtopt={aboutOptions}
        dismissed={dismissed}
        mobile={mobile}
        lang={lang}
        onExit={() => setMobile(false)}
      />
    </header>
  );
};

export default function HeaderStatic(props) {
  return (
    <StaticQuery
      query={graphql`
        {
          info: allWp {
            nodes {
              acfInformation {
                acfInformation {
                  menu {
                    tekst
                    url
                  }
                }
              }
            }
          }
        }
      `}
      render={(data) => <Header data={data} {...props} />}
    />
  );
}
